import { HelmetDexteel } from "@dexteel/mesf-core";
import { SummaryByCloseDateReport } from "./components/SummaryByCloseDateReport";

export const SummaryByCloseDatePage = () => (
	<>
		<HelmetDexteel title="Summary By Close Date" />
		<SummaryByCloseDateReport />
	</>
);
